import * as React from 'react';

import * as styles from './ProjectsList.css';
import { ProjectItem, TEditData } from './ProjectItem';
import { TProject } from 'shared/types/project';
import { Body2 } from '@cian/ui-kit';

interface IProjectsListProps {
  projects: TProject[];
  currentUrl: string;
  onProjectClick: (id: number) => void;
  onProjectEditClick: (data: TEditData) => void;
}

export const ProjectsList: React.FC<IProjectsListProps> = ({
  projects,
  currentUrl,
  onProjectClick,
  onProjectEditClick,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <Body2>Опубликован</Body2>
        <Body2>Название</Body2>
        <Body2>Создан</Body2>
        <Body2>Обновлен</Body2>
        <Body2>Дата макета</Body2>
        <Body2>Хэш</Body2>
        <Body2>Действия</Body2>
      </div>
      <ul className={styles['list']}>
        {projects.map(project => (
          <ProjectItem
            key={project.id}
            {...project}
            onClick={onProjectClick}
            onEditClick={onProjectEditClick}
            currentUrl={currentUrl}
          />
        ))}
      </ul>
    </div>
  );
};
